<template>
  <div id="FeedbackMobile">
    <div class="overlay"></div>
    <div id="FeedbackMobileModal" class="sidenav-mobile">
      <a href="javascript:void(0)" class="closebtn" @click="hide()">&times;</a>

      <div class="FeedbackMobile"></div>
      <div class="backyard"></div>
      <div class="header">
        <div class="logo">
          <img
            v-if="!Config.vendor.custom_ticket_logo"
            :src="ticket.business_summary.photo"
            alt=""
          />
          <img v-else :src="Config.vendor.custom_ticket_logo_path" alt="" />
        </div>
        <div class="name ml-1">
          {{ ticket.business_summary.name }}
          <br />
          <p class="badge2 badge-secondary">
            {{ ticket.business_summary.address }},
            {{ ticket.business_summary.city }}
          </p>
        </div>
      </div>
      <div class="ticket">
        <div class="number">
          <span>{{
            $t("Components.Queue.TicketItem.ThanksForVisiting2")
          }}</span>
        </div>

        <div class="body">
          <div class="info">
            <div class="left">
              <b
                >{{ $t("Components.Queue.TicketItem.ThanksForVisitingThe") }}
                {{ checkinTimeDateFormated }}</b
              >
            </div>
          </div>
          <div class="info">
            <div class="left">
              <b>{{ $t("ServicesPlural") }}</b>
            </div>
          </div>
          <div class="left mt-2">
            <div style="text-align: center">
              <p
                class="badge badge-secondary m-1"
                v-for="item in ticket.services"
                :key="item.id"
              >
                {{ item.title }}
              </p>
            </div>
          </div>
          <span class="info">
            <i
              @click="updateRating(index)"
              :class="
                rating >= index
                  ? 'mdi mdi-star rating-star'
                  : 'mdi mdi-star-outline rating-star'
              "
              :key="index + '-avg-full'"
              v-for="index in 5"
            ></i>
          </span>
          <vs-textarea
            class="textarea-style"
            v-model="feedback_text"
            :placeholder="
              $t('Components.Queue.TicketItem.FeedbackTextPlaceholder')
            "
          />
          <vs-button
            class="w-50"
            style="background: #054479 !important; left: 25%"
            size="small"
            @click="submitFeedback"
          >
            {{ $t("Components.Queue.TicketItem.FeedbackSubmitButton") }}
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import { queueService, bookingService, userService } from "../../_services";
import CancelAppointment from "../modals/CancelAppointment.vue";

export default {
  data: () => ({
    user: null,
    servicesLength: false,
    ticket_uid: null,
    // ticket: null,
    is_running_late: 0,
    seconds_left: null,
    time_left: "--",
    time_left_interval: null,

    cancel_ticket_modal: {
      active: false,
      type: "danger",
    },
    late_modal: {
      active: false,
      type: "warning",
    },

    position: {
      lat: 36,
      lng: 10,
    },
    position_is_correct: false,
    language: localStorage.getItem("Language"),
    show_all_languages: false,
    // *********************************************
    title: "TrackTicket",
    inServiceActive: false,
    inDelayedActive: false,
    inRunningLateActive: false,
    rating: 5,
    feedback_text: "",
    ticket: {
      id: 0,
      public_identifier: "",
      unique_id: "",
      checkinTime: "00:00:00",
      checkinDate: "0000-00-00",
      status: "",
      statusUpdateTimestamp: "",
      estimatedTimeToSpend: 0,
      counter_id: -1,
      customer_id: 0,
      services: [],
      service_names: "",
      business: 0,
      queue_line_id: 0,
      urgent: 0,
      tracked: 0,
      anonymous: 0,
      member_id: -1,
      waiting_time: 0,
      total_waiting: 0,
      business_summary: {
        id: 0,
        name: "",
        address: "",
        postal_code: "",
        phone: "",
        organization_id: "",
      },
      organization_summary: {},
    },
    advertisement: {},
    background_color: "",
    text_color: "",
    theme: "",
    ticketDisplay: "",
    adsActive: false,
    activeRating: false,
    test: true,
    showClose: false,
    video_link: "",
  }),
  components: {
    CancelAppointment,
  },
  computed: {
    checkinTimeDateFormated: function() {
      return this.$moment(
        this.ticket.checkinDate + " " + this.ticket.checkinTime
      ).format("DD MMM YYYY, HH:mm");
    },
    serviceTimeFormated: function() {
      return (
        this.$moment()
          .startOf("day")
          .add(this.ticket.estimatedTimeToSpend, "minutes")
          .format("HH") +
        "H" +
        this.$moment()
          .startOf("day")
          .add(this.ticket.estimatedTimeToSpend, "minutes")
          .format("mm")
      );
    },
    waitingTimeFormated: function() {
      return moment()
        .startOf("day")
        .add(this.ticket.waiting_time, "seconds")
        .format("HH:mm");
    },
    shouldBeThereAt: function() {
      return moment()
        .add(this.ticket.waiting_time, "seconds")
        .format("HH:mm");
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.organization_id = this.Config.organization_id;
  },
  methods: {
    updateRating(r) {
      this.rating = r;
    },
    submitFeedback() {
      if (this.rating < 0) {
        this.activeRating = true;
      } else if (this.rating <= 3 && this.feedback_text.length < 4) {
        //alert("please be more specific");
      } else {
        $("#PreLoader").show();
        let payload = {
          uid: this.ticket_uid,
          rating: this.rating,
          feedback: this.feedback_text,
          anonymous: 0,
        };
        queueService
          .submitFeedbackByUid(payload)
          .then(
            function() {
              location.replace("/");
            }.bind(this)
          )
          .catch(
            function() {
              location.replace("/");
            }.bind(this)
          )
          .finally(
            function() {
              $("#PreLoader").hide();
              this.activeRating = false;
            }.bind(this)
          );
      }
    },
    onClickCancelBooking(id) {
      this.id_booking = id;
      this.cancel_appointment_modal.active = true;
    },
    ConfirmCancelAppointment() {
      this.cancel_appointment_modal.active = false;
      $("#PreLoader").show();
      bookingService
        .cancelBooking(this.id_booking)
        .then(
          function(result) {
            console.log(result);
            location.replace("/");
          }.bind(this)
        )
        .finally(
          function() {
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    CloseCancelAppointment() {
      this.cancel_appointment_modal.active = false;
    },
    editProfile() {
      $("#PreLoader").show();
      this.success_edit = false;
      this.error_edit = false;
      let data = new FormData();

      data.append("fullname", this.user.fullname);
      data.append("email", this.user.email);
      data.append(
        "social_reason",
        this.user.social_reason ? this.user.social_reason : ""
      );
      data.append("_method", "PUT");
      if (document.getElementById("fileInput").files[0]) {
        data.append("photo", document.getElementById("fileInput").files[0]);
      }

      userService
        .update(data)
        .then(
          function(data) {
            this.success_edit = true;

            let actualUser = JSON.parse(localStorage.getItem("user"));
            actualUser.fullname = data.user.fullname;
            actualUser.email = data.user.email;
            actualUser.photo = data.user.photo;
            actualUser.social_reason = data.user.social_reason;
            localStorage.setItem("user", JSON.stringify(actualUser));
            this.user = actualUser;
          }.bind(this)
        )
        .catch(
          function() {
            this.error_edit = true;
          }.bind(this)
        )
        .finally(
          function() {
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    goTo(url) {
      window.location.href = url;
    },
    getWaitingTime(seconds, mines_minutes) {
      let waiting_seconds = seconds - mines_minutes * 60;
      let h = Math.floor(waiting_seconds / 3600);
      let m = Math.floor((waiting_seconds - 3600 * h) / 60);
      let s = Math.floor(waiting_seconds % 60);
      return (h != 0 ? h + "h " : "") + m + " " + this.$t("Min") + " ";
    },
    deleteBooking(id) {
      bookingService.cancelBooking(id).then(function(result) {
        console.log(result);
      });
    },
    initPage(uid) {
      $("#PreLoader").show();
      this.ticket_uid = uid;
      queueService
        .getArchivedTicketByUid(this.ticket_uid)
        .then(
          function(data) {
            if (data.ticket.rated == 1) {
              location.replace("/");
            }
            this.ticket = data.ticket;
            this.is_running_late = this.ticket.running_late;
            this.seconds_left = this.ticket.waiting_time;

            this.time_left_interval = setInterval(
              function() {
                if (this.seconds_left) {
                  let time_left_h = Math.floor(this.seconds_left / 3600);
                  let time_left_m = Math.floor((this.seconds_left % 3600) / 60);
                  let time_left_s = Math.floor((this.seconds_left % 3600) % 60);
                  if (time_left_h > 0) {
                    this.time_left = time_left_h + "h " + time_left_m + "m";
                  } else {
                    this.time_left = time_left_m + "m " + time_left_s + "s";
                  }
                  this.seconds_left--;
                } else {
                  this.time_left = "--";
                }
              }.bind(this),
              1000
            );
          }.bind(this)
        )
        .catch(function() {
          window.location.href = "/";
        })
        .finally(function() {
          $("#PreLoader").hide();
        });
    },
    ignoreFeedback() {
      let payload = {
        id: this.ticket.id,
      };
      queueService.ignoreFeedback(payload).then(function() {
        console.log("ignored");
      }.bind(this));
    },
    show(uid) {
      $("#FeedbackMobileModal").css("bottom", "0");
      $("#FeedbackMobileModal").css("transition", "1.5s");
      $("#FeedbackMobile > .overlay").fadeIn();
      this.initPage(uid);
    },
    hide() {
      this.ignoreFeedback();
      $("#FeedbackMobileModal").css("bottom", "-70%");
      $("#FeedbackMobile > .overlay").fadeOut();
    },
    logout() {
      localStorage.removeItem("user");
      window.location.href = "";
    },
  },
};
</script>

<style lang="scss" scoped>
#FeedbackMobile {
  margin: 0;
  padding: 0;
  .overlay {
    display: none;
    z-index: 999990;
    background: rgba(0, 0, 0, 0.5);
    height: 100vh;
    min-height: -webkit-fill-available;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    cursor: default;
  }
  .header {
    margin-top: 40px;
      display: flex;
      justify-content: flex-start;
      z-index: 999;
      .logo {
        width: 30%;

        img {
          // padding-right: 10px;
          width: 75px;
          border-radius: 5px;
        }
      }
      .name {
        width: 100%;
        color: var(--primary);
        font-weight: bold;
        font-size: 17px;
        .badge2 {
          width: fit-content;
          font-size: 12px;
          margin-top: 10px;
          border-radius: 100px;
          background: var(--secondary);
          color: var(--secondary-font);
          padding: 7px 15px;
        }
      }
      .circle {
        width: 75px;
        text-align: right;
        position: relative;
        img {
          width: 100%;
        }
        .count_down_value {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-font) !important;
          display: block;
          white-space: nowrap;
          margin-left: 5px;
        }
        .ready {
          font-weight: 900 !important;
          color: var(--secondary) !important;
          font-size: 15px;
          // white-space: normal;
          text-align: center;
          // border-top: 2px solid var(--secondary);
          /* border-bottom: 2px solid var(--secondary); */
          padding: 5px;
        }
      }
      .info {
          display: flex;
          justify-content: space-evenly;
          text-align: center;
          /* border-bottom: 2px solid #dfe4ea; */
          padding-bottom: 5px;
          padding-top: 5px;
          .left {
            width: 100%;
            /* border-right: 2px solid #dfe4ea; */
          }
          .right {
            width: 50%;
          }
          span {
            font-size: 15px;
            font-weight: 400;
            display: block;
            color: var(--special-font);
          }
          b {
            font-size: 20px;
            font-weight: 900;
            color: var(--primary);
            font-family: Arial, Helvetica, sans-serif !important;
          }
        }
    }
  .sidenav-mobile {
    padding: 0 40px;
    height: 70%;
    width: 100%;
    position: fixed;
    z-index: 999999;
    bottom: -70%;
    border-radius: 25px 25px 0 0;
    background-color: #fff;
    overflow-x: hidden;
    transition: 1s;
    padding-top: 20px;
    text-align: left;
    .FeedbackMobile {
      text-align: center;
      margin-top: 20px;
      .image {
        img {
          width: 75px;
          height: 75px;
          border-radius: 100%;
        }
        .floating {
          cursor: pointer;
          img {
            width: 25px;
            height: 25px;
            position: absolute;
            margin-left: -30px;
            margin-top: 15px;
          }
        }
      }
      .name {
        font-size: 15px;
        font-weight: 500;
      }
      button {
        margin-top: 20px;
      }
      .edit {
        .group {
          margin-bottom: 10px;
        }
        label {
          display: block;
          font-size: 14px;
          float: left;
          font-weight: bold;
        }
        .input {
          height: 35px;
          border-radius: 5px;
          width: 100%;
          border: 1px solid #ddd;
          padding: 0 10px;
          font-size: 13px;
        }
        .input[type="file"] {
          padding-top: 4px;
        }
        button {
          margin-top: 20px;
        }
      }
    }
    .plans {
      padding: 20px 30px;
      .loader {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        img {
          width: 50px;
        }
      }
      .empty {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        img {
          width: 150px;
        }
      }
      .title {
        //width: 15px;
        width: 100%;
        font-size: 15px;
        color: var(--special-font);
        border-bottom: 3px solid var(--primary);
        border-radius: 2px;
        font-weight: 600;
      }
      .plan {
        margin-top: 20px;
        .content {
          transition: 1s;
          border-radius: 5px;
          cursor: pointer;
          .image {
            text-align: center;
            max-width: 60px !important;
            img {
              border-radius: 5px;
              width: 100%;
            }
          }
          .data {
            padding: 0 0 0 10px;
            .name {
              font-size: 0.9em;
              font-weight: 600;
              margin-left: 5px;
              display: block;
            }
            .address {
              display: block;
            }
            .services {
              color: var(--primary);
              display: block;
            }
            .date {
              font-weight: bold;
              font-size: 0.9em;
              color: var(--secondary);
              img {
                height: 1em !important;
              }
            }
          }
          .status {
            display: inline-block;
            text-align: center;
            //border-left: 1px solid #ddd;
            color: var(--success);
            font-weight: bold;
            padding: 5px 10px 0 10px;
          }
          .button-modif-delete {
            // background: red; // var(--danger);
            border: 1px solid red;
            display: inline-block;
            text-align: center;
            width: 100%;
            border-radius: 32px;
            color: red;
            font-weight: bold;
            padding: 6px 0px;
            margin: 0px 7px 0 16px;
            font-size: 0.9em;
          }
          .color-update {
            color: var(--secondary);
            border: 1px solid var(--secondary);
          }
          .color-delete {
            color: red;
            border: 1px solid red;
          }
          .color-disable {
            color: rgb(88, 88, 88);
            border: 1px solid rgb(88, 88, 88);
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.7;
          }
        }
      }
    }
  }
  .ticket {
      z-index: 9;
      border-radius: 10px;
      // -webkit-filter: drop-shadow(2px 5px 5px #888);
      // filter: drop-shadow(2px 5px 5px #888);
      // border: 1px solid var(--primary);
      // box-shadow: 0 4px 2px -2px #c7ccd3;
      .number {
        padding: 0 0 10px 0;
        text-align: center;
        font-size: 13px;
        font-weight: 900;
        color: var(--primary);
        border-radius: 80px 80px 0 0;
        background: #fff;
      }
      .divider {
        width: 100%;
        z-index: -1;
        margin-top: -15px;
        margin-bottom: -10px;
        .svg {
          width: 100%;
          // padding-right: 0.5px
        }
      }
      .body {
        border-radius: 0 0 10px 10px;
        background: #fff;
        padding: 0 20px 10px 20px;
        line-height: 1.1;
        .info {
          display: flex;
          justify-content: space-evenly;
          text-align: center;
          /* border-bottom: 2px solid #dfe4ea; */
          padding-bottom: 5px;
          padding-top: 5px;
          .left {
            width: 100%;
            /* border-right: 2px solid #dfe4ea; */
          }
          .right {
            width: 50%;
          }
          span {
            font-size: 15px;
            font-weight: 400;
            display: block;
            color: var(--special-font);
          }
          b {
            font-size: 17px;
            font-weight: 900;
            color: var(--primary);
            font-family: Arial, Helvetica, sans-serif !important;
          }
        }
      }
      .services {
        display: flex;
        justify-content: space-between;
        padding: 10px 0 20px 0;
        line-height: 2;
        .left {
          font-weight: bold;
          font-size: 17px;
          width: 40%;
          color: var(--special-font);
        }
        .right {
          text-align: right;
          width: 60%;
          span {
            color: var(--secondary);
            font-weight: bold;
            font-size: 17px;
            display: block;
          }
        }
      }
      .date_join {
        width: 100%;
        text-align: center;
        /* border-bottom: 2px solid #dfe4ea; */
        padding-bottom: 10px;
        small {
          color: var(--special-font);
          font-size: 12px;
        }
        span {
          display: block;
          color: #f7ad36;
        }
      }
      .footer {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;
        .left {
          /* border-right: 2px solid #dfe4ea; */
          width: 50%;
          text-align: center;
          cursor: pointer;
          span {
            color: #f7ad36;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }
        .right {
          width: 50%;
          text-align: center;
          cursor: pointer;
          span {
            color: #e31d1a;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }
      }
    }

  .sidenav-mobile .logout {
    color: var(--special-font);
    float: right;
    right: 20px;
    font-size: 20px;
    position: absolute;
    cursor: pointer;
  }

  .sidenav-mobile .closebtn {
    color: var(--special-font);
    left: 20px;
    top: 5px;
    font-size: 20px;
    position: absolute;
    font-size: 36px;
  }
  // .sidenav .closebtn {
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     font-size: 36px;
  //     margin-left: 50px;
  //     margin-bottom: 10px;
  //     text-align: center;
  //     padding: 0 10px;
  //     border-radius: 5px;
  // }

  @media screen and (max-height: 450px) {
    .sidenav-mobile {
      padding-top: 15px;
    }
    .sidenav-mobile a {
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 800px) {
    .sidenav-mobile {
      width: 100%;
      bottom: -70%;
    }
  }
  button {
    background: var(--primary);
    color: var(--primary-font);
    border-radius: 10px;
    font-size: 15px;
    font-weight: 300;
    padding: 10px 20px;
  }
  button:hover {
    background: var(--primary-hover);
    color: var(--primary-font);
  }
}

/* **************************************** */
.badge {
  margin-top: 10px;
  border-radius: 100px;
  background: var(--secondary);
  color: var(--secondary-font);
  padding: 7px 15px;
}
.download-app {
  max-width: 100%;
  padding: 10px;
  filter: grayscale(100%);
}
.download-app:hover {
  filter: grayscale(0%);
}
.business-info {
  align-items: center;
  justify-content: center;
}
.rating-star {
  color: gold;
  font-size: 46px;
}
.rating-star-small {
  color: gold;
  font-size: 24px;
}
.rating-average {
  font-size: 46px;
  color: lightgray;
}
.vs-avatar--con-img img {
  height: 100%;
}
</style>


